import React from "react";
import Box from "./Box";

interface Props {
    isActive: boolean | undefined
    setIsActive: React.Dispatch<React.SetStateAction<boolean>> | React.Dispatch<React.SetStateAction<boolean | undefined>>
    disabled: boolean
    labelText: string | undefined
    isLabelRequired: boolean
}

const CustomSwitch = ({ isActive, setIsActive, disabled, labelText, isLabelRequired }: Props) => {
    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }

            <Box height="42px" justifyContent="center">
                <Box opacity={disabled ? "0.5" : "1"} height="31px" position="relative">
                    <Box position="absolute" opacity={isActive ? "1" : "0"} width="80px" onClick={disabled ? undefined : () => setIsActive(!isActive)} className={"ebbe-switch actionIcon bg-success"} alignSelf="flex-start" borderRadius="5px" p="3px" flexDirection="row">
                        <Box justifyContent="center">
                            <Box borderRadius="3px" bg="white" width="25px" height="25px" justifyContent="center">&nbsp;</Box>
                        </Box>
                        <Box flexGrow={1} justifyContent="center">
                            <label style={{ fontWeight: 'bold' }} className="text-center text-white m-0 p-0 form-label">Evet</label>
                        </Box>
                    </Box>

                    <Box position="absolute" opacity={isActive ? "0" : "1"} width="80px" onClick={disabled ? undefined : () => setIsActive(!isActive)} className={"ebbe-switch actionIcon bg-danger"} alignSelf="flex-start" borderRadius="5px" p="3px" flexDirection="row">
                        <Box flexGrow={1} justifyContent="center">
                            <label style={{ fontWeight: 'bold' }} className="text-center text-white m-0 p-0 form-label">Hayır</label>
                        </Box>
                        <Box justifyContent="center">
                            <Box borderRadius="3px" bg="white" width="25px" height="25px" justifyContent="center">&nbsp;</Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    )
}

CustomSwitch.defaultProps = {
    disabled: false,
    labelText: undefined,
    isLabelRequired: false
}

export default CustomSwitch;